import * as React from 'react';
import { connect } from 'react-redux';
import CountryDropdown, { CountryDropdownProps } from './CountryDropdown';

const FOREIGN_COUNTRIES_PICKLISTTYPEID = '10f482f2a73ee811b9dc0028f80bded3';

const ForeignCountryDropdown: React.StatelessComponent<CountryDropdownProps> = props => {
	return (
		<CountryDropdown
			{...props}
			countries={props.countries}
		/>
	);
};

function mapStateToProps(state: any, ownProps: any) {
	let countries = state.pickList.items.filter(
		(p: PickListItem) => p.pickListTypeId === FOREIGN_COUNTRIES_PICKLISTTYPEID
	);
	countries = countries.sort((a: PickListItem, b: PickListItem) => {
		if (a.code! < b.code!) {
			return -1;
		}
		if (a.code! > b.code!) {
			return 1;
		}
		return 0;
	});

	return {
		countries: countries
	};
}
export default connect(mapStateToProps)(ForeignCountryDropdown);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/ForeignCountryDropdown.tsx